<div class="container" [ngClass]="{'expanded': expanded}">
    <div class="title-container">
        <h2  class="map-title" [@mapTitle]="expanded ? 'expanded' : 'shrunk'">
            {{ title }}
        </h2>
        <finder-font-icon
            name="icon_close-reversed"
            [title]="closeButtonText"
            theme="primary"
            [hidden]="!expanded || !paradeRoute || hideCloseButton"
            (click)="retractMap($event)">
        </finder-font-icon>
    </div>
    <div class="map-container">
        <a #mapWrapper finderLocale class="map-wrapper" [href]="link" [title]="linkText" (click)="handleClick($event)">
            @defer {
                <finder-map
                    [defaults]="defaults"
                    [markers]="markers"
                    [center]="center"
                    [paradeRoute]="paradeRoute"
                    [maxBounds]="maxBounds"
                    [markerOptions]="markerOptions"
                    (mapIsReady)="listenForMapReady($event)"
                ></finder-map>
            }
        </a>
    </div>
</div>
